// Shared portfolio samples used by both the Portfolio page and the RLAH agent
// samples showcase. Keeping a single source of truth so uploads only need to be
// updated in one place.

const BASE = "/portfolio/samples";

export const PROPERTY_TYPES = [
  { id: "all", label: "All" },
  { id: "condo", label: "Condo" },
  { id: "single-family", label: "Single-family" },
  { id: "townhome", label: "Townhome" },
  { id: "commercial", label: "Commercial" },
];

export const SAMPLES = {
  bw: [
    { src: "/portfolio/samples-new/sample1-1.png", label: "Sample 01", type: "townhome" },
    { src: "/portfolio/samples-new/sample2-1.png", label: "Sample 02", type: "single-family" },
    { src: "/portfolio/samples-new/neptune-1.png", label: "4429 Neptune Dr — Main + Lower Level", type: "single-family" },
    { src: "/portfolio/samples-new/neptune-2.png", label: "4429 Neptune Dr — Main Level w/ Landscape", type: "single-family" },
  ],
  color: [
    { src: `${BASE}/color/1.jpg`, label: "Three-Level Townhouse — Upper / Main / Utility", type: "townhome" },
    { src: `${BASE}/color/2.jpg`, label: "Four-Level Home — Bedrooms / Main / Garage / Loft", type: "single-family" },
    { src: `${BASE}/color/3.jpg`, label: "Upper Bedroom Level — 3 BR + Balcony", type: "condo" },
    { src: `${BASE}/color/4.jpg`, label: "Open Living + Kitchen + Dining — Balcony", type: "condo" },
    { src: `${BASE}/color/5.jpg`, label: "Two-Bedroom Condo — Open Plan w/ Den", type: "condo" },
    { src: `${BASE}/color/6.jpg`, label: "Three-Level Home — Upper / Main / Lower w/ Greenhouse", type: "single-family" },
    {
      src: "https://customer-assets-0z36b82j.emergentagent.net/job_dmv-layouts/artifacts/ul9liqov_Screenshot%202026-08-15%20at%201.01.40%E2%80%AFPM.png",
      label: "Three-Level Townhome — 3 Bedrooms / Kitchen / Rec Room w/ Wet Bar",
      type: "townhome",
    },
    {
      src: "/portfolio/cleaned/meriden.png",
      label: "9907 Meriden Rd, Potomac MD — Aerial Site Render w/ Pool & Landscaping",
      type: "single-family",
    },
    {
      src: "https://customer-assets-0z36b82j.emergentagent.net/job_dmv-layouts/artifacts/p3lqzvw0_ChatGPT%20Image%20Aug%2015%2C%202026%20at%2001_29_41%20PM.png",
      label: "Aerial Estate Render — Rectangular Pool + Motor Court",
      type: "single-family",
    },
    {
      src: "https://customer-assets-0z36b82j.emergentagent.net/job_dmv-layouts/artifacts/dnx17hij_ChatGPT%20Image%20Aug%2015%2C%202026%20at%2001_07_14%20PM.png",
      label: "3D Aerial Site Plan — Home + Backyard w/ Fire Pit & Driveway",
      type: "single-family",
    },
  ],
  redraw: [
    {
      before: `${BASE}/redraw/1-before.jpg`,
      after: `${BASE}/redraw/1-after.jpg`,
      label: "Ranch Home — Master Suite + 3-Car Garage",
      type: "single-family",
    },
    {
      before:
        "https://customer-assets.emergentagent.com/job_dmv-layouts/artifacts/zzclm3ba_IMG_6030.jpg",
      after:
        "https://customer-assets.emergentagent.com/job_dmv-layouts/artifacts/1cucvolv_Screenshot%202026-06-24%20at%2010.03.51%E2%80%AFPM.png",
      label: "Upper Level — Primary Suite + 3 Bedrooms + Multiple Baths",
      type: "single-family",
    },
  ],
};

export const CATEGORIES = [
  {
    id: "bw",
    label: "Black & White",
    chip: "bg-stone-900 text-white",
    activeBtn: "bg-stone-900 text-white border-stone-900",
    blurb: "MLS-ready linework. High contrast. Reads instantly at thumbnail size.",
  },
  {
    id: "color",
    label: "Colorized",
    chip: "bg-teal-700 text-white",
    activeBtn: "bg-teal-700 text-white border-teal-700",
    blurb: "Warm room tones, furniture, textures. Perfect for brochures and social.",
  },
  {
    id: "redraw",
    label: "Redraw",
    chip: "bg-amber-600 text-white",
    activeBtn: "bg-amber-600 text-white border-amber-600",
    blurb: "Send us a dated, cluttered plan — we redraw it crisp and modern.",
  },
];
